// extracted by mini-css-extract-plugin
module.exports = {"cancleBtn":"style_cancleBtn__2BgEK","welcomeImageDiv":"style_welcomeImageDiv__1ZurW","welcomeImage":"style_welcomeImage__34RlW"};